import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "./ui/alert-dialog";

/**
 * ConfirmDialog — sostituisce window.confirm con dialog Radix accessibile.
 * Variant: "default" | "destructive" | "warning"
 *
 * Uso controllato:
 *   <ConfirmDialog open={...} onCancel={...} onConfirm={...} title="..." description="..." variant="destructive" />
 */
export function ConfirmDialog({
  open, onCancel, onConfirm,
  title = "Confermare l'azione?",
  description = "",
  confirmLabel = "Conferma",
  cancelLabel = "Annulla",
  variant = "default",
  testId = "confirm-dialog",
}) {
  const colors = {
    default: "bg-[#1B5E20] hover:bg-[#144818] text-white",
    destructive: "bg-[#C62828] hover:bg-[#B71C1C] text-white",
    warning: "bg-[#F57C00] hover:bg-[#E65100] text-white",
  }[variant];

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel?.()}>
      <AlertDialogContent data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className={colors} data-testid={`${testId}-confirm`}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
